import React from "react";
import "../styles/Login.css";
import { useNavigate } from "react-router-dom";

function Login() {
  let navigate = useNavigate();
  function handleSubmit(e) {
    e.preventDefault();
    navigate("/dashboard");
  }
  return (
    <div className="row login-page">
      <div className="col-md-6 image-container">
        <img src="/images/login.png" alt="LoginImage" />
      </div>
      <div className="col-md-6">
        <div className="login-container">
          <div className="logo1">
            <img src="/images/logo.png" alt="LogoImage" />
          </div>
          <div className="form-container">
            <form onSubmit={handleSubmit}>
              <div className="email-container">
                <label>Login</label>
                <input
                  required
                  type="email"
                  placeholder="Employee ID/Email ID"
                  name="email"
                  id="email"
                />
              </div>
              <div className="pwd-container">
                <input
                  required
                  type="password"
                  placeholder="Enter Password"
                  name="pwd"
                  id="pwd"
                />
                <i className="fa-regular fa-eye-slash"></i>
              </div>
              <div>
                <a href="#">Forgot Password</a>
              </div>
              <button type="submit">
                Login to PeopleSole{" "}
                <i className="fa-solid fa-arrow-right-long"></i>
              </button>
            </form>
          </div>
        </div>
        <div className="ft-wrapper">
          {/* <div className="logo2"> */}
          <img src="/images/logo.png" alt="LogoImage" />
          {/* </div> */}
          <a href="#">Privacy Policy</a>
          <a href="#">Terms & Conditions</a>
        </div>
        <hr />
        <div className="ft-container">
          <p>
            &copy;2023 . All rights reserved. Made in India.{" "}
            <i className="fa-solid fa-heart"></i>{" "}
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
